export enum HttpStatusCode {
  NO_CONTENT = 204,
  UNAUTHORIZED = 401,
  BAD_GATEWAY = 502,
  TOO_MANY_REQUESTS = 429,
}
